import { useEffect, useMemo, useState } from 'react';
import { subscribeByComitentes } from '../services/comitentesQueryService';
import { resumirActividad } from '../utils/actividadClientes';

const COLECCIONES = ['operaciones', 'cauciones', 'pases', 'instrucciones'];

const vacio = () => COLECCIONES.reduce((acc, c) => ({ ...acc, [c]: null }), {});

/**
 * Actividad del día de una cartera (ver resumirActividad). Las consultas van
 * acotadas por comitente, así sirve igual para un comercial (staff) y para un
 * productor (las reglas solo le permiten esa lectura).
 *
 * @param {string[]} comitentes
 * @returns {{ totales, porComitente, isLoading: boolean }}
 */
export const useActividadClientes = (comitentes) => {
    const comitentesKey = [...(comitentes || [])].map(String).sort().join('|');
    const [docs, setDocs] = useState({ key: null, data: vacio() });

    useEffect(() => {
        const lista = comitentesKey ? comitentesKey.split('|') : [];
        setDocs({ key: comitentesKey, data: vacio() });
        const unsubs = COLECCIONES.map(coleccion => subscribeByComitentes(
            coleccion,
            lista,
            (items) => setDocs(prev => (prev.key === comitentesKey
                ? { key: prev.key, data: { ...prev.data, [coleccion]: items } }
                : prev)),
            () => setDocs(prev => (prev.key === comitentesKey
                ? { key: prev.key, data: { ...prev.data, [coleccion]: prev.data[coleccion] || [] } }
                : prev)),
        ));
        return () => unsubs.forEach(unsub => unsub());
    }, [comitentesKey]);

    const respondio = docs.key === comitentesKey;
    const isLoading = !respondio || COLECCIONES.some(c => docs.data[c] === null);
    const resumen = useMemo(() => resumirActividad({
        operaciones: docs.data.operaciones || [],
        cauciones: docs.data.cauciones || [],
        pases: docs.data.pases || [],
        instrucciones: docs.data.instrucciones || [],
    }), [docs.data]);

    return { ...resumen, isLoading };
};
